import React, { useEffect, useState } from 'react';
import './Club.css';
import { motion } from 'framer-motion';
import Structure from "../components/Structure/Structure";
import Infrastructures from "../components/Infrastuctures/Infrastructures";
import LoadingSpinner from "../components/LoadingSpinner/LoadingSpinner";
import KeyFigures from "../components/KeyFigures/KeyFigures";
import ProjetNDBF from "../components/ProjetNDBF/ProjetNDBF";
import PalmaresSection from "../components/PalmaresSection/PalmaresSection";
import RecompenseSection from "../components/RecompenseSection/RecompenseSection";
import heroClubImage from "../assets/images/sections/hero_club_2026.jpg";
import heroClubMobile from "../assets/images/sections/hero_club_mobile_2026.jpg";

function Club() {
    const palmares = [
        { id: 1, titre: 'Champion de France', annees: '2015, 2018' },
        { id: 2, titre: 'Coupe Nationale', annees: '2017' },
        { id: 3, titre: 'Champion Régional', annees: '2010, 2013' },
    ];

    const [clubData, setClubData] = useState(null);

    useEffect(() => {
        fetch("https://api-dofa.fff.fr/api/clubs/137104.json")
            .then((response) => response.json())
            .then((data) => setClubData(data))
            .catch((error) => console.error("Error fetching data:", error));
    }, []);

    if (!clubData) {
        return <LoadingSpinner />;
    }
    return (
        <div className="club">
            {/* Section Hero */}
            <section className="hero-club">
                <picture className="hero-club-picture">
                    <source media="(max-width: 768px)" srcSet={heroClubMobile} />
                    <img src={heroClubImage} alt="Nantes Doulon Bottière Futsal" className="hero-club-image" />
                </picture>
                <div className="hero-club-overlay">
                    <div className="hero-club-content">
                        <h1>Nantes Doulon Bottière Futsal</h1>
                        <p className="hero-club-founded">Fondé en 2008</p>
                        <p className="hero-club-values">Respect • Inclusion • Excellence</p>
                        <p className="hero-club-division">National D2</p>
                    </div>
                </div>
            </section>

            {/* Section Chiffres Clés */}
            <KeyFigures />
            {/* Section Notre Palmarès */}
            <PalmaresSection />
            {/* Projet NDBF */}
            <ProjetNDBF />

            {/* Section Structure du Club */}
            <Structure members={clubData.membres} />

            {/* Section Nos Infrastructures */}
            <Infrastructures />
        </div>
    );
}

export default Club;
